/* this file contains details of all the fields required for each page-level content type. This can be used to only render a page if all required fields are present, which is useful when the live preview builds a page based on saved data (rather than published data). */

export const homePageRequiredFields = [
  'enabled',
  'mastheadTitle',
  'mastheadDescription',
  'mastheadCallToAction',
  'latestContentTiles',
  'secondBlockTiles',
  'featuredCircularExample',
  'circularExamples',
  'aboutUsTitle',
  'aboutUsDescription',
  'aboutUsLinks',
  'shouldDisplayTextTooltips',
];

export const standardPageRequiredFields = [
  'enabled',
  'pageType',
  'format',
  'title',
  'listingTitle',
  'slug',
  'listingImage',
  'mastheadImage',
  'topics',
  'resourceContentType',
  'shouldDisplayTextTooltips',
];

export const circularExamplePageRequiredFields = [
  'enabled',
  'format',
  'title',
  'slug',
  'listingTitle',
  'listingImage',
  'mastHeadBackgroundImage',
  'flexibleContent',
  'topics',
  'resourceContentType',
  'shouldDisplayTextTooltips',
];

export const structurePageRequiredFields = [
  'title',
  'enabled',
  'type',
  'slug',
  'colour',
  'subPages',
];

export const subPageRequiredFields = [
  'enabled',
  'format',
  'parentStructure',
  'title',
  'mastheadTitle',
  'slug',
  'tabTitle',
  'listingTitle',
  'listingImage',
  'mastheadImage',
  'flexibleContent',
  'topics',
  'resourceContentType',
  'shouldDisplayTextTooltips',
];

export const webflowPageRequiredFields = [
  'enabled',
  'title',
  'pageType',
  'format',
  'slug',
  'listingTitle',
  'listingImage',
  'webflowUrl',
  'topics',
  'resourceContentType',
];
